module.exports = __webpack_public_path__ + "img/data-loading.2b63a4d2.png";